import { useCallback } from 'react';
import { alertSrc } from '#shared/assets';
import { useConfirm } from '#shared/lib/hooks';

export const useProductsDeleteExternalIDsConfirm = () => {
    const { confirm, renderConfirmModal } = useConfirm();

    const confirmDeleteExternalIDs = useCallback(
        () =>
            confirm({
                title: 'Удалить внешние ID у выбранных товаров?',
                bodyText:
                    'Внешние ID будут удалены для товаров в Архиве. Чтобы заново добавить их — верните товары из архива, скачайте эксель, добавьте Внешние ID',
                imageSrc: alertSrc,
                applyText: 'Да, удалить Внешние ID',
                cancelText: 'Отменить',
            }),
        [confirm]
    );

    return { confirm: confirmDeleteExternalIDs, ProductsDeleteExternalIDsModal: renderConfirmModal() };
};
